import clsx from 'clsx'
import styles from 'components/FormControls/form-controls.module.scss'
import { Checkbox, ControlLabel, HelperText } from 'gu-ui-kit'
import React from 'react'

const renderCheckboxGroup = ({
  input,
  name,
  options,
  meta: { touched, submitting, error } = {},
  ...rest
}) => {
  return (
    <>
      {options.map((opt, i) => (
        <div key={'checkbox-' + name + '-' + i}>
          <ControlLabel
            name={name}
            checked={input.value.includes(opt.value)}
            label={opt.label}
            onChange={(event) => {
              const newVal = event.currentTarget.checked
                ? input.value.concat(opt.value)
                : input.value.filter((v) => v !== opt.value)
              input.onChange(newVal)
            }}
            hidden={!!rest.hidden || rest.type === 'hidden'}
            disabled={submitting || rest.disabled}
            control={<Checkbox />}
          />
        </div>
      ))}
      {((touched && error) || rest.helperText) && (
        <HelperText
          error={!!error}
          className={clsx(styles['radiogroup__helper-text'], {
            [styles['radiogroup__helper-text_error']]: error,
          })}
        >
          {rest.t(error) || rest.helperText}
        </HelperText>
      )}
    </>
  )
}

export default renderCheckboxGroup
